/**
 * Extends Beacon Tile with POP properties
 */

import { unsafeCSS } from 'lit';
import { property, state } from 'lit/decorators.js';
import { BeaconTile } from '@trp-beacon-ui-kit/foundation/components/index.js';

import style from '../base.scss?inline';
import { Constants } from '../base.constants.js';
import { BeaconPopMixin } from './mixin.js';
import { PopBaseInterface } from '../pop-base/types.js';

export interface PopBeaconTile extends BeaconTile, PopBaseInterface {}

export class PopBaseTile extends BeaconPopMixin(BeaconTile) {
  static get styles() {
    return [super.styles, unsafeCSS(style)];
  }
  @state()
  initialized = false;

  /**
   * The optional component object that contains the pre-fetched data to be rendered.
   * @ignore
   */
  @property({
    attribute: Constants.DATA_COMPONENT_OBJECT,
    type: Object,
  })
  componentObject?: unknown;

  protected initialize() {
    this.initialized = true;
  }

  protected render() {
    return super.renderTile();
  }
}
